import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { OrderStatusVm } from './OrderStatusVm';

@NgModule({
  declarations: [OrderStatusVm],
  exports: [OrderStatusVm],
  providers: [],
  imports: [BrowserModule, CommonModule, FormsModule],
})
export class OrderStatusModule {}
